<template>
    <div class="themes">
        <div v-for="(item, index) in themeList" :key="index">
            <div class="theme">
                <div class="themeHead">
                    <p>{{item.name}}</p>
                    <a href="javascript:;" @click="goJxClass(item.classTypeId)">更多</a>
                </div>
                <ul class="themeList">
                    <!-- <li v-for="(child, childIndex) in item.bookList" :key="childIndex" @click="goBookInfo(child.bookId)">
                        <div>
                            <img :src="child.cover" alt="">
                            <p>{{child.readSum}}</p>
                        </div>
                        <p>{{child.bookName}}</p>
                        <p>{{child.authorName}}</p>
                    </li> -->
                    <li v-for="(child, childIndex) in item.bookList" :key="childIndex" @click="goBookInfo(child.bookId)">
                        <div>
                            <img :src="child.cover" alt>
                            <p>{{child.readSum | playNum}}</p>
                        </div>
                        <p>{{child.bookName}}</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    // name: "首页主题"
    data() {
        return {
            themeList: []
        }
    },
    created() {
        var that = this;
        var data = {
            ticket: localStorage.getItem("ticket")
        }
        that.allApi.getChoiceByPidWithBook(data).then(function(resource) {
            // console.log(JSON.parse(resource.data))
            that.themeList = resource.data.data;
        });
    },
    methods: {
        goBookInfo(id) {
            var that = this;
            that.$emit("goBookInfo", id);
        },
        goJxClass(id){
            var that = this;
            that.$router.push({
                path: "/classify",
                query: {
                    id: id
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@function rem($args) {
    $uiWidth: 75px;
    @return $args/$uiWidth*1rem;
}
.themes{
    width: rem(666px);
    margin: 0 auto;
    .theme{
        // padding: rem(40px) rem(30px);
        margin-bottom: rem(60px);
        >.themeHead{
            margin-bottom: rem(30px);
            overflow: hidden;
            > p {
                float: left;
                font-size: rem(36px);
                line-height: rem(50px);
                font-weight: bold;
                color: #111;
                position: relative;
                padding-left: rem(20px);
                &::before{
                    content: "";
                    position: absolute;
                    left: 0;
                    top: rem(13px);
                    overflow: hidden;
                    border-right: rem(5px) solid #349AF6;
                    height: rem(24px);
                }
            }
            >a{
                float: right;
                font-size: rem(24px);
                color: #a5a5b9;
                background: url("../../assets/imgs/index/more.png") center right /
                    rem(18px) rem(29px) no-repeat;
                padding-right: rem(20px);
                line-height: rem(50px);
            }
        }
        >.themeList{
            display: flex;
            justify-content: space-between;
            > li {
                width: rem(210px);
                > div {
                    position: relative;
                    > img {
                        display: block;
                        width: rem(210px);
                        height: rem(210px);
                        border-radius: rem(6px);
                        margin-bottom: rem(22px);
                    }
                    > p {
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        right: 0;
                        height: rem(34px);
                        line-height: rem(34px);
                        font-size: rem(24px);
                        color: #fff;
                        padding: 0 rem(20px);
                        text-indent: rem(20px);
                        border-bottom-left-radius: rem(6px);
                        border-bottom-right-radius: rem(6px);
                        background: url("../../assets/imgs/index/indexThemePlay.png")
                            rem(20px) center / rem(11px) rem(20px) no-repeat,
                            linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
                    }
                }
                > p {
                    text-align: center;
                    font-size: rem(24px);
                    line-height: rem(34px);
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }
    }
}
</style>
